/* eslint-disable react-hooks/exhaustive-deps */
import './header.css'
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import parse from 'html-react-parser';
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { Popup } from '@progress/kendo-react-popup';
import {
    ListView,
} from '@progress/kendo-react-listview';
import PilotApiRepository from '../../../repositories/api/PilotApiRepository';
import { isArrayEmpty, isNullOrEmpty, stopPropagation } from '../../helpers/ObjectHelpers';
import CompensationApiRepository from '../../../repositories/api/CompensationApiRepository';
import { Bell, BellRinging, X } from 'phosphor-react-sc';
import { DebounceService } from '../../../services/DebounceService';
import { IncidentApiRepository } from 'repositories/api/IncidentApiRepository';
import { ApplicationRightService } from 'services/ApplicationRightService';
import { ApplicationRightSystemNames } from 'components/constants/ApplicationRightSystemNames';
import { useApplicationRights, useReloadAlerts } from "components/hooks/useAppStore";

export const HeaderAlerts = () => { 

    const debounceService = new DebounceService();
    const navigate = useNavigate();

    const applicationRights = useApplicationRights();
    const reloadAlerts = useReloadAlerts();

    const [showAlerts, setShowAlerts] = useState(false);
    // renderPopup: Used to render the popup. Without this, the popup will flicker after being opened and closed, and then resize the window
    const [renderPopup, setRenderPopup] = useState(true);
    const [alerts, setAlerts] = useState([]);
    const [alertCount, setAlertCount] = useState(0);

    const headerInterval = React.useRef(null);
    const anchorAlerts = React.useRef(null);

    const alertRender = (props) => {
        const alert = props.dataItem;
        return (
            <div className="header-alert-item" onClick={() => !isNullOrEmpty(alert.urlText) && alert.onClick(alert)}>
                <div className="header-alert-item-content">
                    <div className="text-truncate">
                        {parse(alert.title)}
                    </div>
                    <div>
                        {parse(alert.message)}
                    </div>
                    {
                        !isNullOrEmpty(alert.urlText) &&
                        <div>
                            <div className="header-alert-item-navigate">
                                <span className="reply-link" onClick={() => alert.onClick(alert)}>
                                    {parse(alert.urlText)}
                                </span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    const onResize = () => {
        setRenderPopup(false);
    }

    useEffect(() => {
        headerInterval.current = setInterval(() => initializeAlertsAsync(), 300000);// Check for alerts every 5 minutes
        window.addEventListener("resize", onResize);

        return () => {
            if (!headerInterval.current) {
                clearInterval(headerInterval.current);
            }
            window.removeEventListener("resize", onResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!applicationRights || applicationRights.length === 0) return;
        initializeAlertsAsync();
    }, [applicationRights]);

    useEffect(() => {
        if (!reloadAlerts) return;
        initializeAlertsAsync();
    }, [reloadAlerts]);

    const onBodyClick = () => {
        if (!showAlerts) return;
        setShowAlerts(false);
    }
    useEffect(() => {
        document.body.addEventListener("click", onBodyClick);
        return () => {
            document.body.removeEventListener("click", onBodyClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onBodyClick]);

    useEffect(() => {
        if (showAlerts) return;
        debounceService.executeEvent(() => setRenderPopup(false), 750)
    }, [showAlerts]);

    useEffect(() => {
        if (renderPopup) return;
        debounceService.executeEvent(() => setRenderPopup(true))
    }, [renderPopup]);

    return (
        <>
            <div>
                <button ref={anchorAlerts} onClick={onToggle} className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base" style={{ border: "0px" }}>
                    <BadgeContainer>
                        {
                            alertCount > 0 ?
                                <>
                                    <BellRinging size={32} weight="duotone" className="header-notification-active" />
                                    <Badge themeColor="primary">{alertCount}</Badge>
                                </>
                                :
                                <Bell weight="duotone" size={32} />
                        }
                    </BadgeContainer>
                </button>
            </div>
            {
                (renderPopup) &&
                <Popup
                    anchor={anchorAlerts.current}
                    show={showAlerts}
                    popupClass={'header-popup-content'} style={{ left: "0px" }}>
                    {
                        alertCount === 0 ?
                            <>
                                <div className="header-alert-header">
                                    <div>
                                        <Bell weight="duotone" size={40} />
                                    </div>
                                    <div>
                                        Varsler
                                    </div>
                                    <div>
                                        <X size={32} onClick={close} className="pointer" />
                                    </div>
                                </div>
                                <div className="header-alert-content" style={{ padding: 15 }}>
                                    Du har ingen nye varsler.
                                </div>
                            </>
                            :
                            <>
                                <div className="header-alert-header">
                                    <div>
                                        <BellRinging size={40} weight="duotone" />
                                    </div>
                                    <div>
                                        {alertCount} {alertCount === 1 ? "nytt varsel" : "nye varsler"}
                                    </div>
                                    <div>
                                        <X size={32} onClick={close} className="pointer" />
                                    </div>
                                </div>
                                <div className="header-alert-content">
                                    <ListView
                                        className="header-alert-list"
                                        data={alerts}
                                        item={alertRender}
                                    />
                                </div>
                            </>
                    }
                    <div className="header-alert-footer"></div>
                </Popup>
            }

        </>
    );

    function onToggle(e) {
        stopPropagation(e);
        setShowAlerts(!showAlerts);
    }

    async function initializeAlertsAsync() {

        const pilotAssignmentAlerts = await getPilotHseAlertsAsync();
        const compensationCorrectionAlerts = await getCompensationCorrectionAsync();
        const incidentCorrectionAlerts = await getIncidentCorrectionAsync();

        const alerts = pilotAssignmentAlerts.concat(compensationCorrectionAlerts).concat(incidentCorrectionAlerts);

        if (isNullOrEmpty(alerts)) {
            setAlertCount(0);
            setAlerts([]);
            return;
        };
        setAlerts(alerts);
        setAlertCount(alerts.length);
    }

    function onAlertClickAsync(alert) {
        onToggle();
        if (isNullOrEmpty(alert.url)) return;
        navigate(alert.url);
    }

    async function getPilotHseAlertsAsync() {
        const pilotHseAlerts = [];
        let personDataValidities = [];

        if (navigator.onLine) {
            const response = await PilotApiRepository.getPilotDataValidity();
            if (response.ok === true) {
                let pilotDataValidity = await response.json();
                personDataValidities = pilotDataValidity;
            }
        }

        if (isNullOrEmpty(personDataValidities)) return [];

        personDataValidities.forEach((personDataValidity) => {
            pilotHseAlerts.push(createHseAlert(personDataValidity));
        })

        return pilotHseAlerts;
    }

    async function getCompensationCorrectionAsync() {
        const result = [];
        const response = await CompensationApiRepository.getPilotCompensations();

        if (response.ok) {
            const data = await response.json();
            const compensations = data.filter((c) => c.isCorrectionRequired);
            if (!isArrayEmpty(compensations)) {
                result.push(
                    {
                        title: "Korrigering kreves",
                        message: `Det er ${compensations.length} tillegg som krever korrigering`,
                        url: `/pilot/compensation?correction=true`,
                        urlText: "G&aring; til Tillegg",
                        onClick: onAlertClickAsync,
                    });
            }
        }
        return result;
    }

    async function getIncidentCorrectionAsync() {
        const applicationRightService = new ApplicationRightService(applicationRights);
        const canAccess = applicationRightService.canAccess([
            ApplicationRightSystemNames.WEB_MODULE_INCIDENTS_WRITE,
            ApplicationRightSystemNames.WEB_MODULE_INCIDENTS_CASEHANDLER_WRITE
        ]);

        if (!canAccess) return [];

        const result = [];
        const response = await IncidentApiRepository.getIncidentCorrectionsAsync();

        if (response.ok) {
            const data = await response.json();
            const corrections = data.numberOfPilotCorrections;
            if (corrections !== 0) {
                result.push(
                    {
                        title: "Korrigering kreves på hendelse",
                        message: `Det er ${corrections} ${corrections === 1 ? "hendelse" : "hendelser"} som krever korrigering.`,
                        url: "/incident/",
                        urlText: "G&aring; til Hendelser",
                        onClick: onAlertClickAsync,
                    });
            }
        }
        return result;
    }

    function createHseAlert(personDataValidity) {
        if (isNullOrEmpty(personDataValidity.expiredText)) {
            return {
                title: `${personDataValidity.name}`,
                message: `${personDataValidity.soonExpiredText}`,
                url: `hse/${personDataValidity.typeGroupSystemName}`,
                onClick: onAlertClickAsync,
                obj: personDataValidity,
                urlText: 'G&aring; til HMS-data',
            }
        }
        return {
            title: `${personDataValidity.name}`,
            message: `${personDataValidity.expiredText}`,
            url: `/hse/${personDataValidity.typeGroupSystemName}`,
            onClick: onAlertClickAsync,
            obj: personDataValidity,
            urlText: 'G&aring; til HMS-data',
        };
    }
}

